import { ChangeDetectionStrategy, Component, ViewChild, OnInit, Renderer2 } from '@angular/core'
import { FormGroupDirective, Validators } from '@angular/forms'

import { FormComponent } from '../../../core/base/form-component'
import { FormsService } from '../../../core/services/forms.service'
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-forgot-account-page',
  templateUrl: './template.html',
  styleUrls: ['./styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotAccountPageComponent extends FormComponent implements OnInit {
  @ViewChild(FormGroupDirective) formGroupDir: FormGroupDirective
  fullWidthView$: Observable<boolean>

  constructor(
    private forms: FormsService,
    private store: Store<any>,
    private renderer: Renderer2,
    private route: ActivatedRoute
  ) {
    super()
    this.fullWidthView$ = store
      .pipe(
        select(fromBase.isFullWidthViewEnabled)
      )

    this.form = this.forms.group({
      email: [
        '', [Validators.required, Validators.email], 'forgot.fields.email'
      ]
    })
  }

  ngOnInit()
  {
    // add login class to body for background image
    this.renderer.addClass(document.body, 'login');

    this.route.queryParams.pipe(
      filter(params => params.email)
    ).subscribe(params => {
        this.form.patchValue({
          email: params.email
        })
      })
  }

  ngOnDestroy() {
    // remove login class
    this.renderer.removeClass(document.body, 'login');
  }

}
